"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardAction = CardAction;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["title", "onClick", "children", "color", "disabled"];
var _default = exports["default"] = function _default(_ref) {
  var className = _ref.className,
    sender = _ref.sender,
    subject = _ref.subject,
    actions = _ref.actions,
    onClick = _ref.onClick,
    tooltip = _ref.tooltip;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full p-4 pt-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('shadow-lg select-none bg-app h-full w-full', {
      'cursor-pointer': !!onClick
    }, className),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-4 pb-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, sender.avatar, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 ml-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm font-semibold truncate text-dark"
  }, sender.name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs truncate text-gray-light"
  }, sender.email))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm truncate text-gray-light my-2"
  }, subject))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-2"
  }, _react["default"].Children.map(actions, function (action, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index,
      className: "mr-4 last:mr-0"
    }, action);
  }))));
};
var colors = {
  primary: 'text-primary hover:bg-secondary',
  secondary: 'text-gray-light hover:bg-secondary'
};
function CardAction(_ref2) {
  var title = _ref2.title,
    _onClick = _ref2.onClick,
    children = _ref2.children,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var textColor = colors[color];
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('text-sm font-semibold py-1 px-2 rounded', (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, textColor, !disabled), 'text-gray-light cursor-not-allowed', disabled)),
    onClick: function onClick(e) {
      e.stopPropagation();
      !disabled && _onClick(e);
    }
  }), children);
}
//# sourceMappingURL=SenderCard.js.map